import { Injectable } from '@angular/core';
import { InRoomDiningPage } from '../../pages/in-room-dining/in-room-dining';
import { RoomServicePage } from '../../pages/room-service/room-service';
import { ReviewsPage } from '../../pages/reviews/reviews';
import { GalleryPage } from '../../pages/gallery/gallery';
import { WeatherPage } from '../../pages/weather/weather';
import { CameraPage } from '../../pages/camera/camera';
import { PlanADayPage } from '../../pages/plan-a-day/plan-a-day';

/*
  Generated class for the ModuleLinkProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ModuleLinkProvider {

  modulePages = {
    'in-room-dining': InRoomDiningPage,
    'room-service': RoomServicePage,
    'reviews': ReviewsPage,
    'gallery': GalleryPage,
    'weather': WeatherPage,
    'camera': CameraPage,
    'planaday': PlanADayPage,
  };

  constructor() { }

  getModule(key) {
    return this.modulePages[key];
  }
}



// WEBPACK FOOTER //
// ./src/providers/module-link/module-link.ts